// AB Test: Images ATF — Winner rollout (Desktop only; Control on mobile)
(function () {
  function injectSeeMoreItem() {
    const grid = document.querySelector(".oke-mediaGrid-container");
    if (!grid) return;

    const existing = grid.querySelector(".see-more-injected");
    if (existing) existing.remove();

    const items = grid.querySelectorAll(
      ".oke-mediaGrid-item:not(.see-more-injected)"
    );
    const itemCount = items.length;

    const isBelowLargeGrid = window.innerWidth < 1430; // align with CSS breakpoint
    if ((isBelowLargeGrid && itemCount === 5) || (!isBelowLargeGrid && itemCount === 8)) {
      const newItem = document.createElement("div");
      newItem.className = "oke-mediaGrid-item see-more-injected";

      const mediaDiv = document.createElement("div");
      mediaDiv.className = "oke-media";
      newItem.appendChild(mediaDiv);

      const button = document.createElement("button");
      button.type = "button";
      button.className = "oke-media-link c-see-more-btn";
      button.textContent = "See More";

      button.addEventListener("click", () => {
        const targetBtns = document.querySelectorAll(".oke-mediaGrid-item");
        const lastBtn = targetBtns[targetBtns.length - 2]; // second-to-last item
        if (lastBtn) {
          const linkBtn = lastBtn.querySelector(".oke-media-link");
          if (linkBtn) {
            linkBtn.click();
          }
        }
      });

      mediaDiv.appendChild(button);
      grid.appendChild(newItem);
    }
  }

  function initImagesATF() {
    const isDesktopForImagesATF = window.innerWidth >= 1024;
    if (!isDesktopForImagesATF) return;

    document.body.classList.add("c-images-atf-test");

    setTimeout(() => {
      injectSeeMoreItem();
      const gridContainer = document.querySelector(".oke-mediaGrid-container");
      if (gridContainer) {
        const mutationObserver = new MutationObserver(() =>
          setTimeout(() => {
            injectSeeMoreItem();
          }, 1000)
        );
        mutationObserver.observe(gridContainer, { childList: true, subtree: true });
      }
    }, 4000);
  }

  document.addEventListener("DOMContentLoaded", initImagesATF);
})();


